
import { useRef } from 'react';

export default function HeroSection() {
  const dialogRef = useRef<HTMLDialogElement>(null);

  const openDialog = () => {
    dialogRef.current?.showModal();
  };

  const closeDialog = () => {
    dialogRef.current?.close();
  };

  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Magical%20Christmas%20night%20scene%20with%20three%20wise%20men%20kings%20camping%20in%20the%20desert%20under%20starry%20sky%2C%20warm%20golden%20campfire%20light%2C%20traditional%20Middle%20Eastern%20tents%2C%20mystical%20atmosphere%2C%20beautiful%20winter%20landscape%20with%20snow-covered%20mountains%20in%20background%2C%20cinematic%20lighting%2C%20festive%20Christmas%20spirit%2C%20royal%20camping%20setup%20with%20ornate%20decorations&width=1920&height=1080&seq=hero1&orientation=landscape')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Campamento Real
            </h1>
            <h2 className="text-2xl md:text-3xl mb-6 text-red-300">
              ¡Aviso importante!
            </h2>
            <p className="text-xl mb-8 text-gray-200 leading-relaxed">
              La organización del Campamento Real de Alcoy informa que, de común acuerdo con el
              Ayuntamiento de Alcoy, y ante la previsión de condiciones meteorológicas adversas que
              podrían comprometer la seguridad de las personas asistentes, voluntariado y personal
              implicado, se ha acordado la suspensión de la presente edición del Campamento Real, en
              aplicación del principio de prevención y seguridad. Se hace constar expresamente que
              los accesos al Campamento Real tienen naturaleza
              <span className="text-red-200">...</span>{' '}
              <button
                type="button"
                onClick={openDialog}
                className="text-red-200 underline underline-offset-4 hover:text-red-100"
              >
                Leer más
              </button>
            </p>
            <dialog
              ref={dialogRef}
              className="max-w-3xl w-[90%] rounded-lg p-0 text-gray-900"
            >
              <div className="bg-white p-6">
                <h3 className="text-2xl font-semibold mb-4">Comunicado oficial</h3>
                <div className="space-y-4 text-base leading-relaxed text-gray-700">
                  <p>
                    La organización del Campamento Real de Alcoy informa que, de común acuerdo con
                    el Ayuntamiento de Alcoy, y ante la previsión de condiciones meteorológicas
                    adversas que podrían comprometer la seguridad de las personas asistentes,
                    voluntariado y personal implicado, se ha acordado la suspensión de la presente
                    edición del Campamento Real, en aplicación del principio de prevención y
                    seguridad.
                  </p>
                  <p>
                    Se hace constar expresamente que los accesos al Campamento Real tienen
                    naturaleza de donativo, destinado a sufragar los gastos derivados de la
                    organización, planificación y ejecución del evento. En el momento de la
                    adopción de esta decisión, una parte sustancial de dichos gastos ya ha sido
                    realizada, incluyendo, entre otros, infraestructuras, materiales, logística,
                    permisos y servicios contratados.
                  </p>
                  <p>
                    En consecuencia, no procede la devolución de las cantidades aportadas en
                    concepto de accesos, al tratarse de donativos no reembolsables.
                  </p>
                  <p>
                    Asimismo, se informa que los accesos adquiridos para la presente edición no
                    serán válidos para futuras ediciones del Campamento Real, las cuales, en su
                    caso, contarán con un nuevo proceso de organización y puesta a la venta de
                    accesos independiente, bajo las condiciones que se establezcan en cada momento.
                  </p>
                  <p>
                    La organización agradece la comprensión y colaboración de las personas
                    participantes ante una decisión adoptada por causa de fuerza mayor, y reitera
                    su compromiso de seguir trabajando para que futuras ediciones puedan celebrarse
                    en condiciones óptimas de seguridad.
                  </p>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={closeDialog}
                    className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700"
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </dialog>
          </div>
          
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/40f88d0dea4cb4de19f5f0c481deadea/2457b6ac6258a328b7f8e558fc94666a.png" 
                alt="Screenshot 1 APP" 
                className="w-64 h-auto transform rotate-12 shadow-2xl rounded-lg"
              />
              <img 
                src="https://static.readdy.ai/image/40f88d0dea4cb4de19f5f0c481deadea/22cbd48c474d7cbb8426dcf122a9a280.png" 
                alt="Screenshot 2 APP" 
                className="w-64 h-auto absolute top-8 left-8 transform -rotate-6 shadow-2xl rounded-lg"
              />
              <img 
                src="https://static.readdy.ai/image/40f88d0dea4cb4de19f5f0c481deadea/978c736f481ef387255e4a88afb78521.png" 
                alt="Screenshot 3 APP" 
                className="w-64 h-auto absolute top-16 left-16 shadow-2xl rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
